import DashboardTabs from '@/components/DashboardTabs.vue';
import { webUploaderGuides } from '@/config/webUploaderGuides';
import backgroundManager from '@/mixins/backgroundManager';
export default {
  name: 'WebUploaderGuide',
  components: {
    DashboardTabs
  },
  mixins: [backgroundManager],
  data() {
    return {
      guides: webUploaderGuides
    };
  },
  mounted() {
    this.initializeBackground('adminBkImg', '.guide-page', false, true);
  }
};